export default "__VITE_ASSET__DPEtnY7U__"